var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 750.576,
    height: 370.178,
    viewBox: "0 0 750.576 370.178",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 750.576,
    height: 370.178,
    fill: "#0ef5ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_694",
    "data-name": "Groupe 694",
    transform: "translate(0 0)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_103",
    "data-name": "Trac\\xE9 103",
    d: "M63.08,13.348,17.652,273.641H75.974l4.5-25.16H46.942L88.233,13.348Z",
    transform: "translate(53.319 40.316)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_104",
    "data-name": "Trac\\xE9 104",
    d: "M69.818,38.691l4.507-25.156H46.27L41.216,38.7Z",
    transform: "translate(124.494 40.882)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_36",
    "data-name": "Groupe 36",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_35",
    "data-name": "Groupe 35",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_105",
    "data-name": "Trac\\xE9 105",
    d: "M345.381,173.5a58.751,58.751,0,0,0,10.514-13.151,46.633,46.633,0,0,0,5.814-15.945l15.773-89.368a40.056,40.056,0,0,0-.37-16.339,32.519,32.519,0,0,0-6.573-13.324A35.7,35.7,0,0,0,358.7,16.35c-6.059-3-15.768-3-15.768-3H191.607L160.074,191.714,138.291,13.347H113.135L66.947,276.193H92.1L123.644,97.838l21.783,178.355h25.156L212.353,38.5h23.1l-42.059,237.69h25.152L260.616,38.5h29.093l-41.765,237.69H273.1l15.013-85.979,22.539,85.979h28.16l-23.653-89.368a43.652,43.652,0,0,0,16.146-3.936,51.2,51.2,0,0,0,14.08-9.392m-28.727-11.824H293L314.768,38.134h23.661q7.129,0,11.274,4.9c2.75,3.261,3.751,7.289,3,12.045l-16.15,89.646a19.253,19.253,0,0,1-6.939,12.054,19.664,19.664,0,0,1-12.958,4.9",
    transform: "translate(202.215 40.314)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_106",
    "data-name": "Trac\\xE9 106",
    d: "M231.039,251.037H167.181l16.524-93.5h63.846l4.515-25.165H188.212L204.724,38.5h63.858l4.5-24.791-89.754-.366L137.139,276.194h89.376Z",
    transform: "translate(414.233 40.317)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_107",
    "data-name": "Trac\\xE9 107",
    d: "M60.978,276.187,93.13,185.34,129.693,81.32l-.386,194.867h25.16l.752-262.826H127.811L86.17,132.337H49.833l-8.64,25.16H77.361L35.817,276.187Z",
    transform: "translate(108.187 40.358)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_108",
    "data-name": "Trac\\xE9 108",
    d: "M53.449,233.991l5.17-28.883L89.481,28.872h73.294L167.941.418,64.919,0,0,370.178H102.588l5.191-28.875H34.484Z",
    transform: "translate(0 0)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_109",
    "data-name": "Trac\\xE9 109",
    d: "M210.275,0l-5.191,28.875H278.37L259.409,136.187l-5.166,28.883-30.87,176.236h-73.29l-5.17,28.457,103.022.414L312.862,0Z",
    transform: "translate(437.714 -0.001)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_110",
    "data-name": "Trac\\xE9 110",
    d: "M37.756,113.766l381.616-.418,5.17-28.457H42.946Z",
    transform: "translate(114.043 256.412)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_111",
    "data-name": "Trac\\xE9 111",
    d: "M44.237,28.234h2.694l4.5-25.45h4.664L56.58.09H44.559l-.486,2.694h4.664Z",
    transform: "translate(133.122 0.27)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_112",
    "data-name": "Trac\\xE9 112",
    d: "M59.427,25.54H52.712l1.769-10.011h5.424l.487-2.694H54.968L56.733,2.784h6.714L63.926.13,54.441.09,49.492,28.234h9.456Z",
    transform: "translate(149.492 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_113",
    "data-name": "Trac\\xE9 113",
    d: "M56.3,26.867a3.585,3.585,0,0,0,1.262.965,3.916,3.916,0,0,0,1.689.362h.724a4.738,4.738,0,0,0,1.813-.362,5.918,5.918,0,0,0,1.6-.965,5.6,5.6,0,0,0,1.23-1.427,5.041,5.041,0,0,0,.663-1.749l.567-3.216H63.16l-.567,3.216A2.206,2.206,0,0,1,60.462,25.5h-.72a1.484,1.484,0,0,1-1.206-.523,1.525,1.525,0,0,1-.326-1.287l3.377-19.1a2.032,2.032,0,0,1,.748-1.287,2.107,2.107,0,0,1,1.383-.523h.728a1.492,1.492,0,0,1,1.2.523,1.518,1.518,0,0,1,.318,1.287L65.4,7.809h2.706l.555-3.216a4.179,4.179,0,0,0-.04-1.749,3.481,3.481,0,0,0-.708-1.427A3.584,3.584,0,0,0,66.654.452,3.908,3.908,0,0,0,64.961.09h-.72a4.7,4.7,0,0,0-1.805.362,5.841,5.841,0,0,0-1.608.965A5.6,5.6,0,0,0,59.6,2.844a5.131,5.131,0,0,0-.667,1.749l-3.373,19.1a4.179,4.179,0,0,0,.04,1.749,3.385,3.385,0,0,0,.708,1.427",
    transform: "translate(167.59 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_114",
    "data-name": "Trac\\xE9 114",
    d: "M66,15.529h4.342l-2.252,12.7h2.69l2.256-12.7.478-2.694L75.768.13H73.075l-2.3,12.7H66.437L68.692.09H66L61.053,28.233h2.69Z",
    transform: "translate(184.413 0.27)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_115",
    "data-name": "Trac\\xE9 115",
    d: "M73.143,9.136l2.332,19.1h2.694L83.114.09h-2.69l-3.377,19.1L74.715.09H72.021L67.072,28.234h2.694Z",
    transform: "translate(202.593 0.27)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_116",
    "data-name": "Trac\\xE9 116",
    d: "M74.276,26.867a3.69,3.69,0,0,0,1.271.965,3.865,3.865,0,0,0,1.689.362h.724a4.743,4.743,0,0,0,1.805-.362,6.088,6.088,0,0,0,1.608-.965A5.835,5.835,0,0,0,82.6,25.439a4.972,4.972,0,0,0,.667-1.749l3.377-19.1a4.388,4.388,0,0,0-.04-1.749,3.531,3.531,0,0,0-.708-1.427A3.658,3.658,0,0,0,84.632.452,3.916,3.916,0,0,0,82.944.09H82.22a4.738,4.738,0,0,0-1.813.362,6.151,6.151,0,0,0-1.608.965,5.747,5.747,0,0,0-1.226,1.427,4.8,4.8,0,0,0-.659,1.749l-3.377,19.1a4.248,4.248,0,0,0,.04,1.749,3.52,3.52,0,0,0,.7,1.427M79.567,4.593a2.048,2.048,0,0,1,.74-1.287,2.094,2.094,0,0,1,1.387-.523h.724a1.5,1.5,0,0,1,1.21.523,1.564,1.564,0,0,1,.322,1.287l-3.377,19.1A2.214,2.214,0,0,1,78.437,25.5h-.724a1.508,1.508,0,0,1-1.21-.523,1.533,1.533,0,0,1-.314-1.287Z",
    transform: "translate(221.901 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_117",
    "data-name": "Trac\\xE9 117",
    d: "M98.389,6.48H79.818l-.446,2.493H97.951Z",
    transform: "translate(239.744 19.572)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_118",
    "data-name": "Trac\\xE9 118",
    d: "M93.757,27.872a5.962,5.962,0,0,0,1.608-.965,5.509,5.509,0,0,0,1.226-1.427,4.97,4.97,0,0,0,.667-1.749l1.122-6.393a4.247,4.247,0,0,0-.04-1.749,3.545,3.545,0,0,0-.683-1.427,5.2,5.2,0,0,0,1.853-3.176l1.126-6.393a4.245,4.245,0,0,0-.04-1.749,3.432,3.432,0,0,0-.708-1.427A3.585,3.585,0,0,0,98.626.452,3.916,3.916,0,0,0,96.937.09H91.666L86.721,28.234h5.231a4.713,4.713,0,0,0,1.805-.362m.205-25.088h2.5a1.478,1.478,0,0,1,1.2.523,1.525,1.525,0,0,1,.326,1.287l-1.126,6.393a2.08,2.08,0,0,1-.744,1.287,2.112,2.112,0,0,1-1.391.523H92.193Zm-2.256,12.7h2.537a1.508,1.508,0,0,1,1.21.523,1.551,1.551,0,0,1,.314,1.295l-1.162,6.417a2.078,2.078,0,0,1-.748,1.295,2.12,2.12,0,0,1-1.383.523H89.941Z",
    transform: "translate(261.943 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_119",
    "data-name": "Trac\\xE9 119",
    d: "M96.965,22.645h5.347v5.589h2.694L105.094.09h-2.939L92.3,28.234h2.694Zm5.387-15.278-.04,12.584H97.93Z",
    transform: "translate(278.798 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_120",
    "data-name": "Trac\\xE9 120",
    d: "M103.093,19.057l2.42,9.207h3.015L105.992,18.7a4.725,4.725,0,0,0,1.725-.422,5.372,5.372,0,0,0,1.508-1.005,6.322,6.322,0,0,0,1.126-1.407,4.965,4.965,0,0,0,.627-1.709l1.689-9.569a4.387,4.387,0,0,0-.04-1.749,3.432,3.432,0,0,0-.708-1.427,3.658,3.658,0,0,0-1.262-.965A3.916,3.916,0,0,0,108.967.08V.12h-5.231L98.791,28.264h2.7Zm2.859-16.283h2.529a1.508,1.508,0,0,1,1.21.523,1.541,1.541,0,0,1,.322,1.291l-1.729,9.6a2.052,2.052,0,0,1-.744,1.295,2.112,2.112,0,0,1-1.391.523H103.62Z",
    transform: "translate(298.401 0.241)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_121",
    "data-name": "Trac\\xE9 121",
    d: "M123.889,6.48H105.318l-.446,2.493h18.579Z",
    transform: "translate(316.768 19.572)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_122",
    "data-name": "Trac\\xE9 122",
    d: "M113.026,26.867a3.691,3.691,0,0,0,1.27.965,3.865,3.865,0,0,0,1.689.362h.724a4.728,4.728,0,0,0,1.805-.362,6.11,6.11,0,0,0,1.612-.965,5.817,5.817,0,0,0,1.222-1.427,4.969,4.969,0,0,0,.667-1.749l.559-3.216h-2.694l-.559,3.216a2.206,2.206,0,0,1-2.135,1.809h-.724a1.482,1.482,0,0,1-1.52-1.809l3.373-19.1a2.038,2.038,0,0,1,.74-1.287,2.1,2.1,0,0,1,1.391-.523h.72a1.5,1.5,0,0,1,1.21.523,1.546,1.546,0,0,1,.322,1.287l-.563,3.216h2.694l.563-3.216a4.245,4.245,0,0,0-.04-1.749,3.525,3.525,0,0,0-.7-1.427,3.674,3.674,0,0,0-1.266-.965A3.9,3.9,0,0,0,121.694.09h-.72a4.758,4.758,0,0,0-1.817.362,6.219,6.219,0,0,0-1.608.965,5.832,5.832,0,0,0-1.226,1.427,4.88,4.88,0,0,0-.659,1.749l-3.377,19.1a4.246,4.246,0,0,0,.04,1.749,3.52,3.52,0,0,0,.7,1.427",
    transform: "translate(338.946 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_123",
    "data-name": "Trac\\xE9 123",
    d: "M127.716,25.54h-6.795l4.5-25.45H122.73l-4.949,28.144h9.456Z",
    transform: "translate(355.761 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_124",
    "data-name": "Trac\\xE9 124",
    d: "M124.15,26.907a3.736,3.736,0,0,0,1.262.965,3.926,3.926,0,0,0,1.7.362h.724a4.728,4.728,0,0,0,1.805-.362,6.176,6.176,0,0,0,1.612-.965,5.818,5.818,0,0,0,1.222-1.427,4.974,4.974,0,0,0,.667-1.749L137.317.09h-2.694l-4.137,23.641a2.08,2.08,0,0,1-.744,1.287,2.112,2.112,0,0,1-1.391.523h-.724a1.508,1.508,0,0,1-1.21-.523,1.53,1.53,0,0,1-.314-1.287L130.281.09h-2.694L123.4,23.731a4.243,4.243,0,0,0,.048,1.749,3.42,3.42,0,0,0,.7,1.427",
    transform: "translate(372.534 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_125",
    "data-name": "Trac\\xE9 125",
    d: "M136.128,27.872a6.218,6.218,0,0,0,1.608-.965,5.833,5.833,0,0,0,1.226-1.427,4.806,4.806,0,0,0,.659-1.749l1.13-6.393a4.246,4.246,0,0,0-.04-1.749,3.544,3.544,0,0,0-.684-1.427,5.191,5.191,0,0,0,1.845-3.176L143,4.593a4.242,4.242,0,0,0-.04-1.749,3.519,3.519,0,0,0-.7-1.427,3.69,3.69,0,0,0-1.27-.965A3.865,3.865,0,0,0,139.3.09h-5.263l-4.945,28.144h5.231a4.742,4.742,0,0,0,1.805-.362m.205-25.088h2.489a1.494,1.494,0,0,1,1.206.523,1.552,1.552,0,0,1,.326,1.287l-1.134,6.393a2.042,2.042,0,0,1-.744,1.287,2.076,2.076,0,0,1-1.383.523h-2.537Zm-2.255,12.7h2.529a1.508,1.508,0,0,1,1.21.523,1.554,1.554,0,0,1,.322,1.295l-1.17,6.417a2.066,2.066,0,0,1-.74,1.295,2.125,2.125,0,0,1-1.391.523h-2.525Z",
    transform: "translate(389.926 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_126",
    "data-name": "Trac\\xE9 126",
    d: "M154.189,6.48H135.611l-.438,2.493h18.571Z",
    transform: "translate(408.292 19.572)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_127",
    "data-name": "Trac\\xE9 127",
    d: "M149.558,27.872a6.215,6.215,0,0,0,1.608-.965,5.909,5.909,0,0,0,1.226-1.427,4.8,4.8,0,0,0,.659-1.749l3.377-19.1a4.24,4.24,0,0,0-.04-1.749,3.519,3.519,0,0,0-.7-1.427,3.689,3.689,0,0,0-1.27-.965A3.865,3.865,0,0,0,152.73.13l-.04-.04h-5.223l-4.945,28.144h5.231a4.743,4.743,0,0,0,1.805-.362m.157-25.048h2.537a1.508,1.508,0,0,1,1.21.523,1.556,1.556,0,0,1,.322,1.287l-3.426,19.1a2.031,2.031,0,0,1-.736,1.287,2.133,2.133,0,0,1-1.391.523h-2.537Z",
    transform: "translate(430.492 0.271)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_128",
    "data-name": "Trac\\xE9 128",
    d: "M149,26.9a3.766,3.766,0,0,0,1.271.965,3.877,3.877,0,0,0,1.688.362h.728a4.759,4.759,0,0,0,1.805-.362,6.244,6.244,0,0,0,1.612-.965,5.993,5.993,0,0,0,1.222-1.427A5.049,5.049,0,0,0,158,23.721L162.172.08h-5.866L155.9,2.774h3.144l-3.7,20.943a2.2,2.2,0,0,1-2.139,1.813h-.72a1.494,1.494,0,0,1-1.206-.523,1.523,1.523,0,0,1-.322-1.287l.559-3.216h-2.69l-.563,3.216a4.177,4.177,0,0,0,.044,1.749A3.413,3.413,0,0,0,149,26.9",
    transform: "translate(447.625 0.241)",
    fill: "#0ef5ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_129",
    "data-name": "Trac\\xE9 129",
    d: "M155.105,26.867a3.69,3.69,0,0,0,1.27.965,3.865,3.865,0,0,0,1.689.362h.724a4.728,4.728,0,0,0,1.805-.362,6.111,6.111,0,0,0,1.612-.965,5.824,5.824,0,0,0,1.222-1.427,4.971,4.971,0,0,0,.667-1.749l.969-5.428a3.909,3.909,0,0,0-.145-2.05,3.529,3.529,0,0,0-1.146-1.608l-3.864-3.136a1.374,1.374,0,0,1-.478-1.488l.965-5.388a2.039,2.039,0,0,1,.74-1.287,2.112,2.112,0,0,1,1.391-.523h.72a1.5,1.5,0,0,1,1.21.523,1.546,1.546,0,0,1,.322,1.287l-.563,3.216h2.694l.563-3.216a4.245,4.245,0,0,0-.04-1.749,3.523,3.523,0,0,0-.7-1.427,3.674,3.674,0,0,0-1.266-.965A3.9,3.9,0,0,0,163.774.09h-.72a4.758,4.758,0,0,0-1.817.362,6.215,6.215,0,0,0-1.608.965A5.831,5.831,0,0,0,158.4,2.844a4.882,4.882,0,0,0-.659,1.749l-.965,5.428a3.951,3.951,0,0,0,.141,2.05,3.531,3.531,0,0,0,1.146,1.608l3.856,3.136a1.362,1.362,0,0,1,.487,1.488l-.965,5.388a2.09,2.09,0,0,1-.744,1.287,2.112,2.112,0,0,1-1.391.523h-.724a1.481,1.481,0,0,1-1.2-.523,1.51,1.51,0,0,1-.322-1.287l.559-3.216h-2.694l-.559,3.216a4.247,4.247,0,0,0,.04,1.749,3.521,3.521,0,0,0,.7,1.427",
    transform: "translate(466.05 0.271)",
    fill: "#0ef5ff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFond);
export default __webpack_public_path__ + "static/media/logo-fond.75773d828f2c14118bd6875bcebe1f88.svg";
export { ForwardRef as ReactComponent };